import { render, staticRenderFns } from "./MinisiteRegister.vue?vue&type=template&id=8461e6ca&scoped=true&"
import script from "./MinisiteRegister.vue?vue&type=script&lang=js&"
export * from "./MinisiteRegister.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteRegister.vue?vue&type=style&index=0&id=8461e6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8461e6ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8461e6ca')) {
      api.createRecord('8461e6ca', component.options)
    } else {
      api.reload('8461e6ca', component.options)
    }
    module.hot.accept("./MinisiteRegister.vue?vue&type=template&id=8461e6ca&scoped=true&", function () {
      api.rerender('8461e6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteRegister.vue"
export default component.exports